export class stickyScrollElement {

    /**
    * Constructs a new sticky instance.
    *
    * @param stickyItemParent Element parent contenant le sticky
    * @param limiteWrapper container dans lequel le sticky doit se déplacer
    */

    constructor(stickyItemParent, limiteWrapper) {
        this.selector = stickyItemParent;
        this.limiteWrapper = limiteWrapper;
    }

    /**
   * Find elements
   * Ajouter dans votre sélecteur, un element avec la class en sticky 
   * @return {void}
   */
    findElements() {
        this.els = document.querySelector(this.selector + ' .sticky');
    }

    /**
   * Find any elements
   * @return {void}
   */
    init() {
        this.findElements();
        this.stickElement();
    }


    delete() {
        // console.log('delete style sticky ');
        this.findElements();
        this.els.removeAttribute('style');
    }


    stickElement() {
        const stickyItem = this.els;

        if (stickyItem != null) {
            const navDesktop = document.querySelector('.nav-desktop');
            const limitWrapper = document.querySelector(this.limiteWrapper);
            const stickyHeight = stickyItem.offsetHeight;
            const stickyOffsetTop = stickyItem.getBoundingClientRect().top + document.documentElement.scrollTop;
           
            // marge pour que l'élément ne soit pas collé au dessus 
            let margeSticky = navDesktop.offsetHeight + 50;

            // stickyItem.parentNode.style.height = stickyHeight + 'px';

            // console.log( 'sticky pub : ' + stickyOffsetTop );
          

            window.addEventListener('scroll', function () {
                const limitInfos = limitWrapper.getBoundingClientRect();
                margeSticky = navDesktop.offsetHeight + 50;

                if (limitInfos.bottom - margeSticky - stickyHeight <= 0) {
                    // element arrivé en bas de son container
                    // console.log('absolute');
                    stickyItem.style.position = 'absolute';
                    stickyItem.style.bottom = 0 + 'px';
                    stickyItem.style.top = 'inherit';
                    // stickyItem.style.left = 0 + 'px';
                } else if (window.scrollY > stickyOffsetTop - margeSticky) {
                    // element en sticky 
                    // console.log('sticky');
                    stickyItem.style.position = 'fixed';
                    stickyItem.style.top = margeSticky + 'px';
                    stickyItem.style.bottom = 'inherit';
                    // stickyItem.style.left = stickyOffsetLeft + 'px';
                } else {
                    // element en haut de son container (position initial ) 
                    // console.log('initial');
                    stickyItem.style.position = 'relative';
                    stickyItem.style.top = 'inherit';
                    stickyItem.style.bottom = 'inherit';
                    // stickyItem.style.left = 'inherit';
                }
            });
        }
    }
}